import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/appObjectService";
const store = {};
const mutations = {
    GET_APPOBJECT_DETAIL(state, posts) {
        state.appObjectDetail = posts.data;
        state.appObjectDetailChanged = false;
        state.appObjectDetailIsLoading = false;
    },
    GET_ACCESSLIST_FOR_OBJECT(state, posts) {
        state.accessList = posts.data;
        state.accessListChanged = false;
        state.accessListIsLoading = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.appObjectDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_ACCESSLIST_FOR_OBJECT(state, posts) {
        if (posts.success == true) {
            state.accessListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    appObjectDetailIsLoading: false,
    appObjectDetailChanged: false,
    appObjectDetail: {},
    accessListChanged: false,
    accessListIsLoading: false,
    accessList: [],
};
const getters = {};
const actions = {
    getAppObjectDetail({ commit }, data) {
        state.appObjectDetailIsLoading = true;
        axios
            .get(baseUri + '/GetDetailVx?ObjId=' + data.objId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_APPOBJECT_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getAccessListForObject({ commit }, data) {
        state.accessListIsLoading = true;
        axios
            .get(baseUri + '/GetAccessListForObject?ObjId=' + data.objId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_ACCESSLIST_FOR_OBJECT', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveAppObjectDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.appObjectDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },
    saveAccessListForObject({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.accessList));
        axios
            .post(baseUri + '/SaveAccessListForObject', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_ACCESSLIST_FOR_OBJECT', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}